export enum EOpenFactsCategory {
  ALL = 'all',
  MAKEUP = 'makeup',
}
